import * as React from "react";
import { Column, Columns, Stack, Heading } from "@origin-digital/ods-core";
import { BREAK_POINTS } from "@origin-digital/style-guide";
import { ChatItem } from "./ChatItem";
import { ILiveChatItem, LiveChatItem } from "./LiveChatItem";
import { AppleBusinessChat } from "./AppleBusinessChat";
import styled from "styled-components";

const StyledDivider = styled.div`
  height: 216px;
  width: 1px;
  border-left: 1px solid ${({ theme }) => theme.colors.grey200};
  margin-left: 50%;

  @media (max-width: ${BREAK_POINTS.Min.MD}) {
    height: 1px;
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.colors.grey200};
    margin-left: 0;
  }
`;

interface IChatItem {
  title: string;
  body: string;
  icon: React.ReactNode;
}

interface IChatProps {
  liveChat: ILiveChatItem;
  heading: string;
  messenger?: IChatItem;
  other: IChatItem;
  appleBusinessChat?: boolean;
}

export const Chat = ({
  heading,
  messenger,
  other,
  liveChat,
  appleBusinessChat,
}: IChatProps): JSX.Element => {
  return (
    <Stack data-id="chat" space={["large", "xlarge"]}>
      <Heading variant="h3">{heading}</Heading>
      <Columns space="xlarge" collapseBelow="md">
        <Column width="5/12">
          <LiveChatItem
            title={liveChat.title}
            line1={liveChat.line1}
            line2={liveChat.line2}
            icon={liveChat.icon}
            status={liveChat.status}
            onClick={liveChat.onClick}
            buttonLabel={liveChat.buttonLabel}
          />
        </Column>
        <Column width="1/12">
          <StyledDivider data-id="live-chat-divider" />
        </Column>
        {appleBusinessChat ? (
          <Column width="1/4">
            <AppleBusinessChat />
          </Column>
        ) : messenger ? (
          <Column width="1/4">
            <ChatItem
              dataId="messenger"
              title={messenger.title}
              body={messenger.body}
              icon={messenger.icon}
            />
          </Column>
        ) : (
          ((null as unknown) as JSX.Element)
        )}
        <Column width="1/4">
          <ChatItem
            dataId="other"
            title={other.title}
            body={other.body}
            icon={other.icon}
          />
        </Column>
      </Columns>
    </Stack>
  );
};
